import React from "react";
import { GOOGLE_MAPS_API_KEY } from "src/app.config";

import BlockedContentOverlay from "@components/CookieConsent/BlockedContentOverlay/BlockedContentOverlay";
import { COOKIE_CONSENT_KEY, COOKIE_CONSENT_VALUES } from "@constants/cookies";
import { GoogleMapProps } from "@models/shared/shared.model";
import { getCookie } from "@utils/common.utils";
import { APIProvider, Map, Marker } from "@vis.gl/react-google-maps";

const GoogleMap: React.FC<GoogleMapProps> = ({
  coordinates: { latitude = 0.0, longitude = 0.0 },
}) => {
  const lat = parseFloat(latitude as unknown as string) || 0.0;
  const lng = parseFloat(longitude as unknown as string) || 0.0;

  const storedCookie = getCookie(COOKIE_CONSENT_KEY);

  return (
    <BlockedContentOverlay>
      <div
        className="fg-loc-map"
        style={{ height: 268 }}
        data-testid="googleMap-test"
      >
        {storedCookie === COOKIE_CONSENT_VALUES.ALL && (
          <APIProvider apiKey={GOOGLE_MAPS_API_KEY}>
            <Map
              defaultZoom={14}
              defaultCenter={{ lat, lng }}
              gestureHandling={"greedy"}
              disableDefaultUI={true}
            >
              <Marker position={{ lat, lng }} />
            </Map>
          </APIProvider>
        )}
      </div>
    </BlockedContentOverlay>
  );
};

export default GoogleMap;
